import { useTranslation } from "react-i18next";
import { LANGUAGES, setLanguage, type Language } from "@/shared/i18n";
import { cn } from "@/shared/lib/cn";

/** Written as the old mini-shop writes them, so returning customers recognise the control. */
const LABELS: Record<Language, string> = { uz: "UZ", ru: "RU" };
const ORDER: readonly Language[] = ["uz", "ru"];

/**
 * The «UZ | RU» segmented control of the mobile home header and the cabinet (D4): one tap, each option a 44 px
 * touch target around a 32 px pill.
 */
export function LanguageSwitcher({ className }: { className?: string }) {
  const { t, i18n } = useTranslation();
  return (
    <div
      role="radiogroup"
      aria-label={t("language")}
      className={cn("flex items-center rounded-full bg-canvas p-0.5", className)}
    >
      {ORDER.filter((language) => LANGUAGES.includes(language)).map((language) => {
        const active = i18n.language === language;
        return (
          <button
            key={language}
            type="button"
            role="radio"
            aria-checked={active}
            lang={language}
            onClick={() => {
              setLanguage(language);
            }}
            className="flex h-11 min-w-11 items-center justify-center px-0.5"
          >
            <span
              className={cn(
                "flex h-8 min-w-10 items-center justify-center rounded-full px-2 text-body-lg font-semibold transition-colors duration-(--motion-base)",
                active ? "bg-surface text-ink-strong shadow-xs" : "text-muted",
              )}
            >
              {LABELS[language]}
            </span>
          </button>
        );
      })}
    </div>
  );
}
